<template>
    <div class="fm-breadcrumb">
        <nav aria-label="breadcrumb">
          <p v-if="singleFileView">
            <a  text elevation="0" class="breadcrumb-item my-4 py-4" v-on:click="returnToFileManager()">
                    <span>Visit Group File Manager</span>
            </a>
          </p>
          <ol v-else class="breadcrumb"
              v-bind:class="[manager === activeManager ? 'active-manager' : 'bg-light']">
              <!--<li class="breadcrumb-item" v-on:click="selectMainDirectory">-->
              <!--<span class="badge badge-secondary">-->
              <!--<i class="far fa-hdd"></i>-->
              <!--</span>-->
              <!--</li>-->
              <li  class="breadcrumb-item text-truncate"
                  v-for="(item, index) in filteredBreadcrumb"
                  v-bind:key="index"
                  v-bind:class="[filteredBreadcrumb.length === index + 1 ? 'active' : '']"
                  v-on:click="selectDirectory(index + (breadcrumb.length - filteredBreadcrumb.length))">
                  <span>{{ breadcrumbItemName(index + (breadcrumb.length - filteredBreadcrumb.length)) }}</span>
              </li>
          </ol>
        </nav>
    </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    manager: { type: String, required: true },
    basePath: null,
    group: null,
  },
  computed: {
    singleFileView() {
      return this.$store.state.fm[this.manager].targetFile;
    },

    /**
             * Active manager name
             * @returns {default.computed.activeManager|(function())|string|activeManager}
             */
    activeManager() {
      return this.$store.state.fm.activeManager;
    },

    /**
             * Selected Disk for this manager
             * @returns {default.computed.selectedDisk|(function())|default.selectedDisk|null}
             */
    selectedDisk() {
      return this.$store.state.fm[this.manager].selectedDisk;
    },

    /**
             * Selected directory for this manager
             * @returns {default.computed.selectedDirectory|(function())|default.selectedDirectory|null}
             */
    selectedDirectory() {
      return this.$store.state.fm[this.manager].selectedDirectory;
    },
    /**
             * Breadcrumb
             * @returns {*}
             */
    breadcrumb() {
      return this.$store.getters[`fm/${this.manager}/breadcrumb`];
    },
    filteredBreadcrumb() {
      const breadcrumb = this.breadcrumb ? this.breadcrumb.filter(val => val) : [];
      const path = this.group ? this.group.file_manager_path : '';
      const paths = path.split('/').filter(val => val);

      const crumbs = paths && paths.length && breadcrumb && breadcrumb.length ? breadcrumb.filter((val, ind) => (ind >= (paths.length - 1) ? true : val != paths[ind])) : breadcrumb;

      return crumbs;
    },
  },
  methods: {
    returnToFileManager() {
      const baseUrl = window.location.origin + window.location.pathname;
      window.location = baseUrl;
    },
    breadcrumbItemName(index) {
      if (index - (this.breadcrumb.length - this.filteredBreadcrumb.length) == 0 && this.group) {
        return `${this.group.name} Files`;
      }
      return this.breadcrumb && this.breadcrumb.length > index ? this.breadcrumb[index] : '';
    },
    /**
             * Load selected directory
             * @param index
             */
    selectDirectory(index) {
      const path = this.breadcrumb.slice(0, index + 1).join('/');

      // only if this path not selected
      if (path !== this.selectedDirectory) {
        // load directory
        this.$store.dispatch(`fm/${this.manager}/selectDirectory`, { path, history: true });
      }
    },

    /**
             * Select main directory
             */
    selectMainDirectory() {
      if (this.selectedDirectory) {
        this.$store.dispatch(`fm/${this.manager}/selectDirectory`, { path: null, history: true });
      }
    },
  },
};
</script>

<style lang="scss">
    .fm-breadcrumb {

    .breadcrumb {
        flex-wrap: nowrap;
        padding: 0.2rem 0.3rem;
        margin-bottom: 0.5rem;

    &.active-manager {
         background-color: #c2e5eb;
     }

    .breadcrumb-item.hidden {
        display: none;
    }

    .breadcrumb-item:not(.active):hover {
        cursor: pointer;
        font-weight: normal;
        color: #6d757d;
    }
    }
    }
</style>
